import { IIdentifiable } from './identity';
import { IReportConfiguration } from './reportConfiguration';
import { IReportPrompt } from './standardTemplatePrompts';

interface IReportDeNormalized {
  isDimensional: boolean;
  title: string;
  description: string;
  defaultReportConfiguration: IReportConfiguration;
  lensId?: string;
  visibility: 'public' | 'private';
}

export interface ITemplatedSavedView {
  createdAt: string;
  description: string;
  entityId: number;
  id: string;
  previewEmbedId: string;
  reportConfiguration: IReportConfiguration;
  reportId: string;
  title: string;
}

export interface IReportTemplate extends IReportTemplateMetadata {
  report: IReportDeNormalized;
  savedViews: ITemplatedSavedView[];
  prompts: IReportPrompt[];
}

export interface ITemplateReadable extends IReportTemplate {
  enabled: boolean;
}

export interface IReportTemplateMetadata extends IIdentifiable {
  standardReportName: string;
  standardLensTypes: { [key: string]: ILensTypeAssignment }; //to-do need to get the standard lens type... type
  templateGroup?: ReportTemplateGroup; // Optional grouping key to link multiple versions/variants of the same standard report
  description: string; //A description of why this template may exists, why it exists, what the report is like, etc
  creator: string; //Identifier of the Person/Team that owns this template, for the purpose of contact
  updatedAt: number; //UNIX timestamp of when this template was last updated.
  createdAt: number; //UNIX timestamp of when this template was last updated
}

export interface ILensTypeAssignment {
  lensType: string;
}

export enum ReportTemplateGroup {
  budgetSummary = 'budget-summary'
}
